module.exports = __webpack_public_path__ + "img/logo-oficial-segundo-simposio.95efff6f.webp";